var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerifierIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 85.86 85.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        stroke: #fff;\r\n      }\r\n\r\n      .cls-1, .cls-2 {\r\n        fill: none;\r\n        stroke-miterlimit: 10;\r\n        stroke-width: 1.5px;\r\n      }\r\n\r\n      .cls-2 {\r\n        stroke: #5e7db8;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 21.75,
    y1: 11.25,
    x2: 64.11,
    y2: 11.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 74.61,
    y1: 21.75,
    x2: 74.61,
    y2: 64.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 64.11,
    y1: 74.61,
    x2: 21.75,
    y2: 74.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 11.25,
    y1: 64.11,
    x2: 11.25,
    y2: 21.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 71.98,
    y1: 11.25,
    x2: 77.23,
    y2: 11.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 8.63,
    y1: 11.25,
    x2: 13.88,
    y2: 11.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 71.98,
    y1: 74.61,
    x2: 77.23,
    y2: 74.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 8.63,
    y1: 74.61,
    x2: 13.88,
    y2: 74.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.75,
    y: 0.75,
    width: 21,
    height: 21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.75,
    y: 64.11,
    width: 21,
    height: 21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 64.11,
    y: 0.75,
    width: 21,
    height: 21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 64.11,
    y: 64.11,
    width: 21,
    height: 21
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M54.3,46.27h0s.01-2.07.01-4.62v-6.97c0-2.06-1.44-3.83-3.45-4.25l-7.73-1.63c-.59-.12-1.2-.12-1.79,0l-7.73,1.63c-2.01.42-3.45,2.2-3.45,4.25v6.97c0,2.55,0,4.62.01,4.62,0,0-.01,0,0,0,0,0,0,.03,0,.07,0,.07-.02.2-.02.34,0,6.67,5.41,12.08,12.08,12.08s12.08-5.41,12.08-12.08c0-.14-.02-.27-.02-.41"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "36.64 43.71 39.26 47.45 49.05 40.59"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifierIcon2);
export default __webpack_public_path__ + "static/media/verifier-icon-2.0080d2afc4cb37439c6a24a06cf55203.svg";
export { ForwardRef as ReactComponent };